<template>
    <div class="mt-6 lg:mt-10 px-2 lg:px-6 w-full max-w-[90%] mx-auto">
        <section>
            <h2 class="font-mulish text-[24px] font-bold text-[#053A51]">Career History</h2>
            <p class="font-mulish text-[12px] font-normal text-[#053A51]">View your career history</p>
            <div class="mt-4 border border-[#C7C7C7] rounded-[8px] shadow-md p-[14px] space-y-2">
                <!-- Loop through the career array -->
                <div v-for="(item, index) in staffInfo" :key="index"
                    class="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                    <!-- Key -->
                    <span
                        class="text-[#484848] w-full sm:w-[48%] px-[12px] py-[7px] rounded font-mulish font-semibold text-base">
                        {{ item.key }}
                    </span>

                    <!-- Value -->
                    <div v-if="item.key == 'Employment Date'"
                        class="flex flex-col sm:flex-row justify-between rounded items-center w-full mt-2 sm:mt-0 sm:w-[48%] px-[12px] py-[7px]  bg-[#F2F9FF]">
                        <span class="text-[#484848] font-mulish font-semibold text-base">
                            {{ item.value }}
                        </span>
                        <button
                            class="bg-[#0090FF26] px-4 py-1 rounded flex items-center text-[#0090FF] font-mulish font-semibold border-none">
                            Letter of Appointment
                        </button>
                    </div>
                    <!-- Value -->
                    <span v-else
                        class="text-[#484848] w-full sm:w-[48%] px-[12px] py-[7px] bg-[#F2F9FF] rounded font-mulish font-semibold text-base mt-2 sm:mt-0">
                        {{ item.value }}
                    </span>
                </div>
            </div>
            <!-- Incremental Steps -->
            <h3 class="font-mulish text-[18px] font-semibold text-[#053A51] mt-6">Incremental Steps</h3>
            <div class="mt-2 border border-[#C7C7C7] rounded-[8px] shadow-md  overflow-x-auto">
                <table class="min-w-full rounded-[8px] shadow-md text-left">
                    <thead class="bg-[#F9F9F9]">
                        <tr>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">Year
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">MDA
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">
                                Grade/Step
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">Date
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(step, index) in incrementalSteps" :key="index" class="hover:bg-[#F9F9F9]">
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">{{
                                step.year }}</td>
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">
                                {{
                                    step.mda }}</td>
                            <td
                                class="px-4 py-4 text-[#17517E] text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">
                                {{
                                    step.step }}</td>
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">{{
                                step.date }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Promotion History -->
            <h3 class="font-mulish text-[18px] font-semibold text-[#053A51] mt-6">Promotion History</h3>
            <div class="mt-2 border border-[#C7C7C7] rounded-[8px] shadow-md  overflow-x-auto">
                <table class="min-w-full rounded-[8px] shadow-md text-left">
                    <thead class="bg-[#F9F9F9]">
                        <tr>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">UFS
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">Grade
                                Level
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">MDA
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">
                                Notional Effective Date of Promotion
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">
                                Financial Effective Date of Promotion
                            </th>
                            <th class="px-4 py-2 border-b text-[18px] font-semibold font-mulish border-[#C7C7C7]">Letter
                                of Notification
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(step, index) in promotionalSteps" :key="index" class="hover:bg-[#F9F9F9]">
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">{{
                                step.ufs }}</td>
                            <td
                                class="px-4 py-4 text-[16px] text-[#17517E] font-normal font-mulish border-b border-[#C7C7C7]">
                                {{
                                    step.level }}</td>
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">{{
                                step.mda }}</td>
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">{{
                                step.notionalDate }}</td>
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">{{
                                step.financialDate }}</td>
                            <td class="px-4 py-4 text-[16px] font-normal font-mulish border-b border-[#C7C7C7]">
                                <button
                                    class="bg-transparent text-[#0090FF] font-mulish font-semibold border-none">View</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>
</template>

<script setup>
import { fetchStaffCareerHistory } from "@/services/sourceData";
import { ref, onMounted } from "vue";
import moment from "moment";

const getting = ref(true);
const staffInfo = ref([]);
const incrementalSteps = ref([]);
const promotionalSteps = ref([]);

onMounted(async () => {
    try {
        getting.value = true;
        const resp = await fetchStaffCareerHistory();
        const allData = resp || [];

        // 1. Get staff bio (the recruitment record)
        const bio = allData.find((item) => item.type === "recruitment");

        // 2. Map to staffInfo
        if (bio) {
            staffInfo.value = [
                { key: "Name", value: `${bio.firstName} ${bio.middleName} ${bio.lastName}` },
                { key: "Current MDA", value: bio.mdaName },
                { key: "Department", value: bio.departmentName },
                { key: "Grade Level", value: bio.salaryGradeLevel },
                {
                    key: "Employment Date",
                    value: bio.dateOfAppointment ? moment(bio.dateOfAppointment).format("MMM DD, YYYY") : "-",
                },
                {
                    key: "Confirmation Date",
                    value: bio.reportingDate ? moment(bio.reportingDate).format("MMM DD, YYYY") : "-",
                },
                {
                    key: "Retirement Date",
                    value: "-",
                },
            ];
        }

        // 3. Get promotions
        promotionalSteps.value = allData
            .filter((item) => item.type === "promotion")
            .map((p) => ({
                ufs: p.toDesignation,
                level: p.toGradeLevel,
                mda: p.mdaName,
                notionalDate: p.notionalPromotionDate
                    ? moment(p.notionalPromotionDate).format("MMM DD, YYYY")
                    : "-",
                financialDate: p.financialPromotionDate
                    ? moment(p.financialPromotionDate).format("MMM DD, YYYY")
                    : "-",
            }));

        // 4. Incremental steps 
        incrementalSteps.value = [];
    } catch (err) {
        console.error(err);
    } finally {
        getting.value = false;
    }
});
</script>
